<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import { computed } from 'vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const currentShow = computed(() => item.enrichment.upcomingShows.find((show) => show.relative_to_now === 0))
const upcomingShow = computed(() => item.enrichment.upcomingShows.find((show) => show.relative_to_now === 1))

const currentShowContainerElement = ref(null)
const currentShowElement = ref(null)
const upcomingShowContainerElement = ref(null)
const upcomingShowElement = ref(null)

const timelineCurrentShowTitle = ref(null)
const timelineCurrentShowShout = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Upcoming Shows' })
    .from(currentShowContainerElement, { duration: frames(6), xPercent: -130, opacity: 0, ease: 'back.out(.6)' }, frames(14))
    .fromTo(upcomingShowContainerElement, { xPercent: 130, opacity: 0 }, { duration: frames(10), xPercent: 0, opacity: 0.8, ease: 'back.out(.6)' }, '<')
    .add(timelineCurrentShowTitle, `<${frames(7)}`)
    .add(timelineCurrentShowShout, `<${frames(0)}`)
    .to(currentShowContainerElement, { duration: frames(16), opacity: 0.8, ease: 'power4.inOut' }, 5)
    .to(currentShowElement, { duration: frames(16), scale: 0.85, transformOrigin: 'center', backgroundColor: 'rgb(209 213 219)', filter: 'blur(2px)', ease: 'power4.inOut' }, '<')
    .to(upcomingShowContainerElement, { duration: frames(16), opacity: 1, ease: 'power4.inOut' }, '<')
    .from(upcomingShowElement, { duration: frames(16), scale: 0.85, backgroundColor: 'rgb(209 213 219)', transformOrigin: 'center', filter: 'blur(2px)', ease: 'power4.inOut' }, '<')
})

const formatStartTime = (isoString) => {
  const date = new Date(isoString)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}
</script>

<template>
  <ToFullBottomRight>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :scale="3" :position="{ x: 400, y: 800 }" :backgroundColor="colors.q.cr.red.primary" :color="colors.q.cr.red.darker">
      <div class="size-full flex justify-center mt-40 text-q-cr-gray-primary">
        <div ref="currentShowContainerElement">
          <h1 class="font-bold text-white text-8xl text-center mb-6">Nu</h1>
          <div ref="currentShowElement" class="bg-white text-4xl w-[734px] p-6 rounded-[3rem] flex flex-col gap-6">
            <div class="w-[686px] h-[414px] overflow-clip relative rounded-t-[2rem]">
              <img :src="currentShow.header_images.app_now_header_background?.url" class="absolute size-full object-cover" />
              <img :src="currentShow.header_images.app_now_header_foreground?.url" class="absolute size-full object-cover" />
            </div>
            <div>
              <h3 v-if="currentShow.shout" class="font-blackbones normal-case text-6xl text-q-cr-red-primary -mb-2">
                <TextSlideUp :text="currentShow.shout" @timeline="timelineCurrentShowShout = $event" />
              </h3>
              <h2 class="font-bold text-8xl leading-none">
                <CharacterEnlarge :text="currentShow.title" class="leading-none" @timeline="timelineCurrentShowTitle = $event" />
              </h2>
            </div>
          </div>
        </div>
        <div ref="upcomingShowContainerElement">
          <h1 class="text-white text-8xl text-center mb-6"><strong>Straks</strong> om {{ formatStartTime(upcomingShow.start_time) }}</h1>
          <div ref="upcomingShowElement" class="bg-white text-4xl w-[734px] p-6 rounded-[3rem] flex flex-col gap-6">
            <div class="w-[686px] h-[414px] overflow-clip relative rounded-t-[2rem]">
              <img :src="upcomingShow.header_images.app_now_header_background?.url" class="absolute size-full object-cover" />
              <img :src="upcomingShow.header_images.app_now_header_foreground?.url" class="absolute size-full object-cover" />
            </div>
            <div>
              <h3 class="font-blackbones normal-case text-6xl text-q-cr-red-primary -mb-2">{{ upcomingShow.shout }}</h3>
              <h2 class="font-bold text-8xl leading-none">{{ upcomingShow.title }}</h2>
            </div>
          </div>
        </div>
      </div>
    </AnimatedBackground>
  </ToFullBottomRight>
</template>
